function searchBar() {
  var openButton = document.getElementsByClassName('search-open-buttons-container')[0];
  var closeButton = document.getElementsByClassName('close-form-icon')[0];
  var searchForm = document.querySelectorAll('.block-views-exposed-filter-blocksearch-content-search-page form')[0];

  if (searchForm) {
    openButton.onclick = function() {
      searchForm.classList.add('opened');
      this.classList.add('opened');
      closeButton.classList.add('opened');
      document.getElementsByName('search_api_fulltext')[0].focus();
      document.getElementsByClassName('header-wrapper')[0].classList.add('opened');
    };

    closeButton.onclick = function() {
      searchForm.classList.remove('opened');
      openButton.classList.remove('opened');
      this.classList.remove('opened');
      document.getElementsByClassName('header-wrapper')[0].classList.remove('opened');
    }
  }
}
